// MainPage.styles.js

export const designTokens = {
  navy: '#0d1b2a',
  steel: '#1b2d3e',
  accent: '#2e86c1',
  gold: '#d4ac0d',
  goldLight: '#f9e547',
  white: '#ffffff',
  offWhite: '#f0f4f8',
  gray: '#64748b',
  red: '#c0392b'
};

export const styles = {
  wrapper: { 
    backgroundColor: designTokens.white, 
    color: '#334155', 
    margin: 0, 
    padding: 0, 
    boxSizing: 'border-box', 
    WebkitFontSmoothing: 'antialiased' 
  },
  nav: { 
    position: 'fixed', 
    top: 0, 
    left: 0, 
    width: '100%', 
    height: '70px', 
    borderBottom: `2px solid ${designTokens.gold}`, 
    zIndex: 99999, 
    display: 'flex', 
    alignItems: 'center', 
    transition: 'all 0.25s' 
  },
  navContainer: { 
    width: '100%', 
    maxWidth: '1600px', 
    margin: '0 auto', 
    padding: '0 40px', 
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'space-between' 
  },
  logo: { 
    fontFamily: "'Barlow Condensed', sans-serif", 
    fontSize: '24px', 
    fontWeight: '800', 
    color: designTokens.white, 
    letterSpacing: '1px', 
    textTransform: 'uppercase', 
    cursor: 'pointer' 
  },
  trademark: { 
    fontSize: '10px', 
    verticalAlign: 'super', 
    marginLeft: '2px', 
    opacity: 0.4 
  },
  navLinks: { 
    display: 'flex', 
    alignItems: 'center', 
    gap: '20px' 
  },
  navLinkButton: { 
    background: 'none', 
    border: 'none', 
    fontSize: '14px', 
    fontWeight: '600', 
    textTransform: 'uppercase', 
    letterSpacing: '0.5px', 
    cursor: 'pointer', 
    fontFamily: "'Barlow Condensed', sans-serif", 
    transition: 'color 0.2s' 
  },
  navBtn: { 
    background: designTokens.gold, 
    color: designTokens.navy, 
    fontFamily: "'Barlow Condensed', sans-serif", 
    fontSize: '15px', 
    fontWeight: '700', 
    letterSpacing: '1px', 
    textTransform: 'uppercase', 
    padding: '10px 24px', 
    borderRadius: '3px', 
    border: 'none', 
    cursor: 'pointer', 
    transition: 'all 0.2s ease' 
  },
  hero: { 
    background: designTokens.navy, 
    color: designTokens.white, 
    padding: '120px 40px 100px 40px', 
    position: 'relative', 
    overflow: 'hidden' 
  },
  heroInner: { 
    maxWidth: '1100px', 
    margin: '0 auto', 
    position: 'relative', 
    zIndex: 2 
  },
  heroTag: { 
    display: 'inline-flex', 
    alignItems: 'center', 
    gap: '8px', 
    background: 'rgba(212,172,13,0.15)', 
    border: '1px solid rgba(212,172,13,0.4)', 
    color: designTokens.gold, 
    fontFamily: "'Barlow Condensed', sans-serif", 
    fontSize: '13px', 
    fontWeight: '700', 
    letterSpacing: '3px', 
    textTransform: 'uppercase', 
    padding: '8px 18px', 
    borderRadius: '2px', 
    // marginBottom: '28px' 
  },
  heroH1: { 
    fontFamily: "'Barlow Condensed', sans-serif", 
    fontSize: 'clamp(40px, 6vw, 72px)', 
    fontWeight: '800', 
    lineHeight: '1', 
    textTransform: 'uppercase', 
    letterSpacing: '1px', 
    // marginBottom: '24px', 
    maxWidth: '800px' 
  },
  heroDesc: { 
    fontSize: 'clamp(17px, 2vw, 21px)', 
    lineHeight: '1.65', 
    opacity: 0.85, 
    maxWidth: '640px', 
    marginBottom: '48px' 
  },
  heroActions: { 
    display: 'flex', 
    gap: '16px', 
    flexWrap: 'wrap', 
    alignItems: 'center' 
  },
  btnPrimary: { 
    display: 'inline-block', 
    background: designTokens.gold, 
    color: designTokens.navy, 
    fontFamily: "'Barlow Condensed', sans-serif", 
    fontSize: '20px', 
    fontWeight: '800', 
    letterSpacing: '1px', 
    textTransform: 'uppercase', 
    padding: '18px 44px', 
    borderRadius: '3px', 
    border: 'none', 
    textDecoration: 'none', 
    boxShadow: '0 6px 30px rgba(212,172,13,0.35)', 
    cursor: 'pointer', 
    transition: '0.2s ease' 
  },
  btnSecondary: { 
    display: 'inline-block', 
    border: '2px solid rgba(255,255,255,0.3)', 
    color: designTokens.white, 
    fontFamily: "'Barlow Condensed', sans-serif", 
    fontSize: '18px', 
    fontWeight: '600', 
    letterSpacing: '1px', 
    textTransform: 'uppercase', 
    padding: '16px 36px', 
    borderRadius: '3px', 
    textDecoration: 'none', 
    cursor: 'pointer', 
    transition: '0.2s ease' 
  },
  metrics: { 
    background: designTokens.steel, 
    borderBottom: `3px solid ${designTokens.gold}`, 
    padding: '28px 40px' 
  },
  metricsGrid: { 
    display: 'flex', 
    flexWrap: 'wrap', 
    justifyContent: 'center', 
    gap: '48px', 
    maxWidth: '1000px', 
    margin: '0 auto' 
  },
  metricCard: { 
    textAlign: 'center', 
    color: designTokens.white 
  },
  metricNumber: { 
    fontFamily: "'Barlow Condensed', sans-serif", 
    fontSize: 'clamp(36px, 5vw, 52px)', 
    fontWeight: '800', 
    color: designTokens.gold, 
    lineHeight: '1' 
  },
  metricLabel: { 
    fontFamily: "'Barlow Condensed', sans-serif", 
    fontSize: '12px', 
    fontWeight: '600', 
    letterSpacing: '2px', 
    textTransform: 'uppercase', 
    opacity: 0.6, 
    marginTop: '6px' 
  },
  problemSection: { 
    padding: '80px 40px', 
    backgroundColor: designTokens.white, 
    fontFamily: "'Barlow', sans-serif" 
  },
  sectionInner: { 
    maxWidth: '1100px', 
    margin: '0 auto' 
  },
  sectionLabel: { 
    fontFamily: "'Barlow Condensed', sans-serif", 
    fontSize: '20px', 
    fontWeight: '700', 
    letterSpacing: '4px', 
    textTransform: 'uppercase', 
    color: designTokens.accent, 
    marginBottom: '12px' 
  },
  sectionTitle: { 
    fontFamily: "'Barlow Condensed', sans-serif", 
    fontSize: 'clamp(28px, 4vw, 44px)', 
    fontWeight: '800', 
    textTransform: 'uppercase', 
    letterSpacing: '1px', 
    color: designTokens.navy, 
    marginBottom: '16px', 
    lineHeight: '1.1' 
  },
  sectionDesc: { 
    fontSize: '18px', 
    color: designTokens.gray, 
    lineHeight: '1.7', 
    // maxWidth: '700px', 
    marginBottom: '50px' 
  },
  problemGrid: { 
    display: 'grid', 
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', 
    gap: '24px' 
  },
  problemCard: { 
    backgroundColor: designTokens.offWhite, 
    borderRadius: '6px', 
    padding: '32px 28px', 
    borderLeft: `5px solid ${designTokens.red}`, 
    boxShadow: '0 2px 4px rgba(0,0,0,0.01)' 
  },
  problemIcon: { 
    fontSize: '32px', 
    marginBottom: '14px' 
  },
  cardH3: { 
    fontFamily: "'Barlow Condensed', sans-serif", 
    fontSize: '20px', 
    fontWeight: '700', 
    textTransform: 'uppercase', 
    letterSpacing: '0.5px', 
    color: designTokens.navy, 
    marginBottom: '10px' 
  },
  cardP: { 
    fontSize: '15px', 
    color: designTokens.gray, 
    lineHeight: '1.6', 
    margin: 0 
  },
  
  /* --- FIXES FOR THE 'HOW IT WORKS' WORKFLOW SECTION --- */
  howSection: { 
    padding: '80px 40px', 
    backgroundColor: designTokens.navy, 
    fontFamily: "'Barlow', sans-serif",
    color: designTokens.white 
  },
  howGrid: { 
    display: 'grid', 
    gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', 
    gap: '24px',
    marginTop: '40px'
  },
  howStepCard: { 
    backgroundColor: '#112235', 
    borderRadius: '6px', 
    padding: '36px 28px', 
    border: '1px solid rgba(255,255,255,0.05)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    minHeight: '180px'
  },
  stepHeaderGroup: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: '12px',
    marginBottom: '16px'
  },
  howCardTitle: { 
    fontFamily: "'Barlow Condensed', sans-serif", 
    fontSize: '20px', 
    fontWeight: '700', 
    textTransform: 'uppercase', 
    letterSpacing: '0.5px', 
    color: designTokens.white, 
    margin: 0 
  },
  howCardDesc: { 
    fontSize: '15px', 
    color: '#94a3b8', 
    lineHeight: '1.6', 
    margin: 0 
  },
  stepBadge: { 
    fontFamily: "'Barlow Condensed', sans-serif", 
    fontSize: '15px', 
    fontWeight: '800', 
    color: designTokens.navy, 
    backgroundColor: designTokens.gold, 
    width: '28px', 
    height: '28px', 
    borderRadius: '50%', 
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'center',
    flexShrink: 0
  },
  /* ---------------------------------------------------- */

  splitLayout: { 
    display: 'flex', 
    flexWrap: 'wrap', 
    gap: '48px', 
    alignItems: 'center' 
  },
  controlBox: { 
    backgroundColor: designTokens.offWhite, 
    padding: '28px 21px', 
    borderRadius: '6px', 
    border: '1px solid #e2e8f0' 
  },
  inputGroup: { 
    display: 'flex', 
    flexDirection: 'column', 
    gap: '6px' 
  },
  labelInput: { 
    fontFamily: "'Barlow Condensed', sans-serif", 
    fontSize: '12px', 
    fontWeight: '700', 
    color: designTokens.gray, 
    textTransform: 'uppercase', 
    letterSpacing: '1px' 
  },
  selectInput: { 
    padding: '12px', 
    backgroundColor: '#ffffff', 
    border: '1px solid #cbd5e1', 
    borderRadius: '4px', 
    color: designTokens.navy, 
    fontSize: '14px', 
    outline: 'none', 
    fontFamily: 'inherit', 
    cursor: 'pointer' 
  },
  telemetryContainer: { 
    backgroundColor: designTokens.navy, 
    padding: '36px', 
    borderRadius: '8px', 
    border: '1px solid rgba(255,255,255,0.05)' 
  },
  telemetryRow: { 
    display: 'flex', 
    justifyContent: 'space-between', 
    fontSize: '13px', 
    fontFamily: 'monospace', 
    color: '#94a3b8', 
    borderBottom: '1px solid #1e293b', 
    paddingBottom: '8px' 
  },
  accordionWrapper: { 
    backgroundColor: designTokens.offWhite, 
    borderRadius: '4px', 
    marginBottom: '10px', 
    overflow: 'hidden' 
  },
  accordionHeader: { 
    width: '100%', 
    display: 'flex', 
    justifyContent: 'space-between', 
    alignItems: 'center', 
    padding: '20px', 
    background: 'none', 
    border: 'none', 
    cursor: 'pointer' 
  },
  accordionQuestion: { 
    fontFamily: "'Barlow Condensed', sans-serif", 
    fontSize: '16px', 
    fontWeight: '700', 
    color: designTokens.navy, 
    textTransform: 'uppercase', 
    letterSpacing: '0.5px' 
  },
  accordionContent: { 
    padding: '0 20px 20px 48px' 
  },
  formContainer: { 
    backgroundColor: designTokens.steel, 
    padding: '36px', 
    borderRadius: '8px', 
    border: '1px solid rgba(255,255,255,0.05)' 
  },
  textInput: { 
    padding: '12px', 
    backgroundColor: designTokens.navy, 
    border: '1px solid #1e293b', 
    borderRadius: '4px', 
    color: '#ffffff', 
    fontSize: '14px', 
    outline: 'none' 
  },
  submitBtn: { 
    display: 'inline-flex', 
    alignItems: 'center', 
    justifyContent: 'center', 
    background: designTokens.gold, 
    color: designTokens.navy, 
    fontFamily: "'Barlow Condensed', sans-serif", 
    fontSize: '16px', 
    fontWeight: '800', 
    textTransform: 'uppercase', 
    padding: '14px', 
    borderRadius: '4px', 
    border: 'none', 
    cursor: 'pointer', 
    transition: 'background 0.2s' 
  },
  footer: { 
    backgroundColor: '#09111a', 
    borderTop: '1px solid #1e293b', 
    padding: '40px' 
  },
  footerContainer: { 
    maxWidth: '1100px', 
    margin: '0 auto', 
    display: 'flex', 
    flexWrap: 'wrap', 
    justifyContent: 'space-between', 
    alignItems: 'center', 
    gap: '24px' 
  },
  footerLogo: { 
    fontFamily: "'Barlow Condensed', sans-serif", 
    fontSize: '20px', 
    fontWeight: '800', 
    color: designTokens.white, 
    textTransform: 'uppercase', 
    letterSpacing: '0.5px' 
  },
  footerNotice: { 
    fontSize: '12px', 
    color: '#475569', 
    marginTop: '6px' 
  },

  howSection: { 
    padding: '80px 40px', 
    backgroundColor: designTokens.offWhite, // Matches the bright background from the image
    fontFamily: "'Barlow', sans-serif",
    textAlign: 'center' // Centers all text globally in this section
  },

  howGrid: { 
    display: 'grid', 
    gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', 
    gap: '32px',
    marginTop: '60px',
    position: 'relative' // Anchor base point for the line background
  },

  stepConnectorLine: {
    position: 'absolute',
    top: '35px', // Aligns directly with the center-line of the 70px circles
    left: '12%',
    right: '12%',
    height: '2px',
    backgroundColor: designTokens.gold, // Solid gold line track matching the image
    zIndex: 1
  },

  howStepCard: { 
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    position: 'relative',
    zIndex: 2
  },

  stepBadge: { 
    fontFamily: "'Barlow Condensed', sans-serif", 
    fontSize: '24px', 
    fontWeight: '800', 
    color: designTokens.gold, // Gold text inside circle
    backgroundColor: designTokens.navy, // Navy body color fill
    width: '70px', 
    height: '70px', 
    borderRadius: '50%', 
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'center',
    border: `4px solid ${designTokens.gold}`, // Double ring effect from the image
    marginBottom: '24px',
    boxShadow: `0 0 0 8px ${designTokens.offWhite}`, // Masks out the connector line cleanly
    zIndex: 3
  },

  howCardTitle: { 
    fontFamily: "'Barlow Condensed', sans-serif", 
    fontSize: '18px', 
    fontWeight: '800', 
    textTransform: 'uppercase', 
    letterSpacing: '0.5px', 
    color: designTokens.navy, // High contrast text header
    margin: '0 0 12px 0' 
  },

  howCardDesc: { 
    fontSize: '15px', 
    color: '#475569', // Clean description color from layout picture
    lineHeight: '1.6', 
    margin: 0,
    maxWidth: '280px' // Keeps paragraph text nicely wrapped and balanced
  },

  problemCardBase: {
    backgroundColor: '#112235', // Match a clean dark tint to sit on steel background
    borderRadius: '6px',
    padding: '32px 28px',
    borderLeft: `5px solid ${designTokens.accent}`, // Using accent color for solution section
    display: 'flex',
    flexDirection: 'column',
    transition: 'transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94), box-shadow 0.3s ease, border-color 0.3s ease',
    cursor: 'pointer'
  },

  // The style state applied dynamically on hover
  problemCardHover: {
    transform: 'translateY(-6px)', // Lifts the card slightly up
    boxShadow: '0 12px 24px rgba(0, 0, 0, 0.3)', // Deepens the background shadow drop
    borderColor: designTokens.goldLight // Shifts left accent bar to a golden glow highlight
  },

  btnPrimary: { 
    display: 'inline-block', 
    background: designTokens.gold, 
    color: designTokens.navy, 
    fontFamily: "'Barlow Condensed', sans-serif", 
    fontSize: '20px', 
    fontWeight: '800', 
    letterSpacing: '1px', 
    textTransform: 'uppercase', 
    padding: '18px 44px', 
    borderRadius: '3px', 
    border: '2px solid transparent', // Keeps heights matching perfectly
    boxShadow: '0 6px 30px rgba(212,172,13,0.25)', 
    cursor: 'pointer', 
    transition: 'transform 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94), background-color 0.2s ease, box-shadow 0.2s ease' 
  },

  btnSecondary: { 
    display: 'inline-block', 
    backgroundColor: '#112235', // Premium dark tint background inside the hero
    border: `2px solid rgba(255, 255, 255, 0.15)`, 
    color: designTokens.white, 
    fontFamily: "'Barlow Condensed', sans-serif", 
    fontSize: '18px', 
    fontWeight: '600', 
    letterSpacing: '1px', 
    textTransform: 'uppercase', 
    padding: '16px 36px', 
    borderRadius: '3px', 
    cursor: 'pointer', 
    transition: 'transform 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94), background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease' 
  }
};